import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

function InputDecimal(props) {
  const { name, inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={({ value }) => {
        onChange({
          target: {
            name,
            value,
          },
        });
      }}
      thousandSeparator={false}
      isNumericString
      decimalSeparator="."
    />
  );
}

InputDecimal.propTypes = {
  name: PropTypes.string,
  inputRef: PropTypes.any,
  onChange: PropTypes.func,
};

export default InputDecimal;
